function ellipsis(str, maxLength) {
    if(!str) return ''
    if(!str.length) return ''

    if (str.length > maxLength) {
        return str.substr(0, maxLength) + '...';
    }
    return str;
}

export default ellipsis;



// WEBPACK FOOTER //
// ./common/js/lib/ellipsis.js